import { liteClient as algoliasearch } from 'algoliasearch/lite'

const ALGOLIA_APP = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID
const ALGOLIA_SEARCH_API_KEY = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY

const algoliaClient = algoliasearch(ALGOLIA_APP, ALGOLIA_SEARCH_API_KEY)

const searchClient = {
  ...algoliaClient,
  search(requests) {
    const hasQuery = requests.some((req) => req.params?.query?.trim().length > 2)

    if (!hasQuery) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          processingTimeMS: 0,
        })),
      })
    }

    return algoliaClient.search(requests)
  },
}

export default searchClient
